import * as TypeGraphQL from "type-graphql";
export var MarketCondition;
(function (MarketCondition) {
    MarketCondition["NORMAL"] = "NORMAL";
    MarketCondition["VOLATILE"] = "VOLATILE";
    MarketCondition["ILLIQUID"] = "ILLIQUID";
    MarketCondition["HIGH_SPREAD"] = "HIGH_SPREAD";
    MarketCondition["PRE_MARKET"] = "PRE_MARKET";
    MarketCondition["AFTER_HOURS"] = "AFTER_HOURS";
    MarketCondition["MARKET_OPEN"] = "MARKET_OPEN";
    MarketCondition["MARKET_CLOSE"] = "MARKET_CLOSE";
})(MarketCondition || (MarketCondition = {}));
TypeGraphQL.registerEnumType(MarketCondition, {
    name: "MarketCondition",
    description: undefined,
});
//# sourceMappingURL=MarketCondition.js.map